import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import apiService from '../services/api.service';
import './BlogDetails.css';

const BlogDetails = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchBlog();
  }, [id]);

  const fetchBlog = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await apiService.getCmsBlogBySlug(id);
      setBlog(response.data);
    } catch (err) {
      console.error('Error fetching CMS blog details:', err);
      setError('Unable to load this blog post.');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  return (
    <>
      <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2>{blog?.title || 'Blog Details'}</h2>
            </div>
          </div>
        </div>
      </div>

      <section className="blog-detail-section">
        <div className="container">
          {loading ? (
            <div className="blog-detail-state">Loading blog...</div>
          ) : error ? (
            <div className="blog-detail-state">
              <p>{error}</p>
              <Link to="/blog" className="blog-detail-back">Back to Blogs</Link>
            </div>
          ) : (
            <article className="blog-detail-card">
              {blog.featuredImageUrl && (
                <div className="blog-detail-image">
                  <img src={blog.featuredImageUrl} alt={blog.title} />
                </div>
              )}
              <div className="blog-detail-content">
                <div className="blog-detail-meta">
                  {blog.publishedUtc && <span>{formatDate(blog.publishedUtc)}</span>}
                  {blog.categoryName && <span>{blog.categoryName}</span>}
                  {blog.authorDisplayName && <span>{blog.authorDisplayName}</span>}
                </div>
                <h1>{blog.title}</h1>
                {blog.excerpt && <p className="blog-detail-excerpt">{blog.excerpt}</p>}
                <div
                  className="blog-detail-body"
                  dangerouslySetInnerHTML={{ __html: blog.htmlContent || '' }}
                />
                <Link to="/blog" className="blog-detail-back">Back to Blogs</Link>
              </div>
            </article>
          )}
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
